let apiBaseUrl;
if (process.env.REACT_APP_API_ENDPOINT) {
  apiBaseUrl = process.env.REACT_APP_API_ENDPOINT;
} else {
  throw new Error('Unable to load api base path');
}
export const API_BASE_URL = apiBaseUrl;
